import React from 'react';
import PropTypes from 'prop-types';

import { SCOPES } from '../../constants';
import { buildTCLinkURL } from '../../utils';

const propTypes = {

	/**
	 * The link URL (in absolute format ONLY).
	 */
	url: PropTypes.string.isRequired,

	/**
	 * The link target.
	 */
	target: PropTypes.oneOf(['self', '_blank']).isRequired,

	/**
	 * The link ID (if any), used to generate LRS statements.
	 */
	resourceId: PropTypes.string,

	/**
	 * The link scope.
	 */
	scope: PropTypes.oneOf([SCOPES.SESSION, SCOPES.ORGANIZATION]).isRequired,

	/**
	 * The link scope ID.
	 */
	scopeId: PropTypes.string.isRequired,

	/**
	 * The link content.
	 */
	children: PropTypes.node,

	/**
	 * Custom callback function to handle clicking the link.
	 *
	 * NOTE: This can be used to manually navigate via
	 *       react-router for internal links.
	 */
	onClick: PropTypes.func,

};

const defaultProps = {
	target: '_blank',
};

const CustomLink = (props) => {

	const {
		url,
		target,
		resourceId,
		scope,
		scopeId,
		children,
		onClick,
		...restProps
	} = props;

	return (
		<a
			href={buildTCLinkURL(url, scope, scopeId, resourceId)}
			target={target}
			rel="noopener"
			onClick={onClick}
			{...restProps}>
			{children}
		</a>
	);

};

CustomLink.propTypes = propTypes;
CustomLink.defaultProps = defaultProps;

export default CustomLink;
